function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import { Tokenizer, TokenParser, TokenType, TokenizerError } from '@streamparser/json';
import JSON2CSVBase from './BaseParser.js';

var JSON2CSVStreamParser = /*#__PURE__*/function (_JSON2CSVBase) {
  _inherits(JSON2CSVStreamParser, _JSON2CSVBase);

  var _super = _createSuper(JSON2CSVStreamParser);

  function JSON2CSVStreamParser(opts, asyncOpts) {
    var _this;

    _classCallCheck(this, JSON2CSVStreamParser);

    _this = _super.call(this, opts);
    _this._hasWritten = false;
    if (_this.opts.fields) _this.preprocessFieldsInfo(_this.opts.fields, _this.opts.defaultValue);

    _this.initTokenizer(_this.opts, asyncOpts);

    return _this;
  }

  _createClass(JSON2CSVStreamParser, [{
    key: "initTokenizer",
    value: function initTokenizer(opts) {
      var asyncOpts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      if (asyncOpts.objectMode) {
        this.tokenizer = this.getObjectModeTokenizer();
        return;
      }

      if (opts.ndjson) {
        this.tokenizer = this.getNdJsonTokenizer(asyncOpts);
        return;
      }

      this.tokenizer = this.getBinaryModeTokenizer(asyncOpts);
      return;
    }
  }, {
    key: "getObjectModeTokenizer",
    value: function getObjectModeTokenizer() {
      var _this2 = this;

      return {
        write: function write(data) {
          return _this2.pushLine(data);
        },
        end: function end() {
          _this2.pushHeaderIfNotWritten();

          _this2.onEnd();
        }
      };
    }
  }, {
    key: "configureCallbacks",
    value: function configureCallbacks(tokenizer, tokenParser) {
      var _this3 = this;

      tokenizer.onToken = tokenParser.write.bind(this.tokenParser);

      tokenizer.onError = function (err) {
        return _this3.onError(err);
      };

      tokenizer.onEnd = function () {
        if (!_this3.tokenParser.isEnded) _this3.tokenParser.end();
      };

      tokenParser.onValue = function (_ref) {
        var value = _ref.value;
        return _this3.pushLine(value);
      };

      tokenParser.onError = function (err) {
        return _this3.onError(err);
      };

      tokenParser.onEnd = function () {
        _this3.pushHeaderIfNotWritten();

        _this3.onEnd();
      };
    }
  }, {
    key: "getNdJsonTokenizer",
    value: function getNdJsonTokenizer(asyncOpts) {
      var tokenizer = new Tokenizer(Object.assign(Object.assign({}, asyncOpts), {
        separator: this.opts.eol
      }));
      this.tokenParser = new TokenParser({
        paths: ['$'],
        keepStack: false,
        separator: this.opts.eol
      });
      this.configureCallbacks(tokenizer, this.tokenParser);
      return tokenizer;
    }
  }, {
    key: "getBinaryModeTokenizer",
    value: function getBinaryModeTokenizer(asyncOpts) {
      var _this4 = this;

      var tokenizer = new Tokenizer(asyncOpts);

      tokenizer.onToken = function (_ref2) {
        var token = _ref2.token,
            value = _ref2.value;

        if (token === TokenType.LEFT_BRACKET) {
          _this4.tokenParser = new TokenParser({
            paths: ['$.*'],
            keepStack: false
          });
        } else if (token === TokenType.LEFT_BRACE) {
          _this4.tokenParser = new TokenParser({
            paths: ['$'],
            keepStack: false
          });
        } else {
          _this4.onError(new Error('Data items should be objects or the "fields" option should be included'));

          return;
        }

        _this4.configureCallbacks(tokenizer, _this4.tokenParser);

        _this4.tokenParser.write({
          token: token,
          value: value
        });
      };

      tokenizer.onError = function (err) {
        return _this4.onError(err instanceof TokenizerError ? new Error('Data should be a valid JSON object or array') : err);
      };

      tokenizer.onEnd = function () {
        _this4.pushHeaderIfNotWritten();

        _this4.onEnd();
      };

      return tokenizer;
    } // TODO this should be narrowed based on options

  }, {
    key: "write",
    value: function write(data) {
      this.tokenizer.write(data);
    }
  }, {
    key: "end",
    value: function end() {
      if (this.tokenizer && !this.tokenizer.isEnded) this.tokenizer.end();
    }
  }, {
    key: "pushHeaderIfNotWritten",
    value: function pushHeaderIfNotWritten() {
      if (this._hasWritten) return;

      if (!this.opts.fields) {
        this.onError(new Error('Data should not be empty or the "fields" option should be included'));
        return;
      }

      this.pushHeader();
    }
    /**
     * Generate the csv header and pushes it downstream.
     */

  }, {
    key: "pushHeader",
    value: function pushHeader() {
      if (this.opts.withBOM) {
        this.onData("\uFEFF");
      }

      if (this.opts.header) {
        var header = this.getHeader();
        this.onHeader(header);
        this.onData(header);
        this._hasWritten = true;
      }
    }
    /**
     * Transforms an incoming json data to csv and pushes it downstream.
     *
     * @param {Object} data JSON object to be converted in a CSV row
     */

  }, {
    key: "pushLine",
    value: function pushLine(data) {
      var _this5 = this;

      var processedData = this.preprocessRow(data);

      if (!this._hasWritten) {
        if (!this.opts.fields) {
          if (_typeof(processedData[0]) !== 'object') {
            throw new Error('Data items should be objects or the "fields" option should be included');
          }

          this.opts.fields = this.preprocessFieldsInfo(Object.keys(processedData[0]), this.opts.defaultValue);
        }

        this.pushHeader();
      }

      processedData.forEach(function (row) {
        var line = _this5.processRow(row);

        if (line === undefined) return;

        _this5.onLine(line);

        _this5.onData(_this5._hasWritten ? _this5.opts.eol + line : line);

        _this5._hasWritten = true;
      });
    } // No idea why eslint doesn't detect the usage of these

    /* eslint-disable @typescript-eslint/no-unused-vars */

    /* c8 ignore start */

  }, {
    key: "onHeader",
    value: function onHeader(header) {
      /* To be set by the user */
    }
  }, {
    key: "onLine",
    value: function onLine(line) {
      /* To be set by the user */
    }
  }, {
    key: "onData",
    value: function onData(data) {
      /* To be set by the user */
    }
  }, {
    key: "onError",
    value: function onError(err) {
      /* To be set by the user */
    }
  }, {
    key: "onEnd",
    value: function onEnd() {
      /* To be set by the user */
    }
  }]);

  return JSON2CSVStreamParser;
}(JSON2CSVBase);

export { JSON2CSVStreamParser as default };